import React from 'react';
export default function Strong(props) {
  return /*#__PURE__*/React.createElement("strong", props.dataAttributes, props.children);
}